import classnames from 'classnames';
import { intlShape } from 'react-intl';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';
import { isExternalVideo } from 'shared/ui-selectors/video/video-origin';

import Spinner from 'shared/components/spinner/loading-spinner';

import styles from './overlay.styl';

import { pickContextTypes } from '../context-types';
import translations from './translations';


@WixConnect(styles)
export default class Overlay extends React.Component {

  static contextTypes = pickContextTypes(
    'videoItem',
    'togglePause',
    'error',
    'paused',
    'ended',
    'loading',
    'beenPlayed',
    'videoUrls',
    'fullScreen',
    'simple',
    'mobileMode'
  );

  static propTypes = {
    actions: React.PropTypes.element,
    className: React.PropTypes.string,
    intl: intlShape,
  };

  get errorMessage() {
    const { error } = this.context;
    const { intl: { formatMessage } } = this.props;

    if (!error) {
      return null;
    }

    return (
      <p styleName="error-text">{formatMessage(translations.sourceError)}</p>
    );
  }

  get loadingSpinner() {
    const { ended, error, loading, videoUrls } = this.context;
    if (ended || error) {
      return null;
    }

    if (videoUrls && (error || !loading)) {
      return null;
    }

    return (
      <Spinner />
    );
  }

  get isExternalVideo() {
    const { videoItem } = this.context;
    return isExternalVideo(videoItem);
  }

  get beenPlayedContent() {
    if (this.isExternalVideo) {
      return null;
    }

    return (
      <div styleName="been-played-content">
        {this.errorMessage}
        {this.loadingSpinner}
      </div>
    );
  }

  render() {
    const { actions, className } = this.props;
    const {
      simple,
      mobileMode,
      videoItem,
      error,
      loading,
      togglePause,
      paused,
      ended,
      beenPlayed,
      videoUrls,
      fullScreen,
    } = this.context;

    if (simple || mobileMode) {
      return null;
    }

    const canPlay = !error && !loading;

    const styleNames = classnames('overlay', {
      'video-url-loading': !videoUrls && !this.isExternalVideo,
      'not-been-played': !beenPlayed,
      'been-played': beenPlayed,
      'at-full-screen': fullScreen,
      ended,
      paused,
    });

    const overlayOnClick = (canPlay && beenPlayed) ? togglePause : _.noop;

    return (
      <div onClick={overlayOnClick}
           styleName={styleNames}
           className={className}>
        {this.beenPlayedContent}

        <div styleName="hover-content">
          {actions}
          <h1 styleName="title"
              className="qa-overlay-title"
              data-hook="playerTitle">
            {videoItem.title}
          </h1>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/overlay/overlay.js